/* eslint-disable style/no-tabs */
import { useTranslation } from "react-i18next";

function SecurityFailedPicture() {
  const { t } = useTranslation("security");

  return (
    <>
      <p>
        {t("security:kyc-failed-picture-intro")}
        {/* We regret to inform you that your recent submission for the
				identification verification process has encountered an issue related to
				image quality, which has prevented us from successfully processing your
				verification request. */}
      </p>
      <p>
        {t("security:kyc-failed-picture-header")}
        {/* The issue could be down to a multitude of reasons including: */}
      </p>
      <div class="w-full h-4" />
      <ul>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-picture-list-header-1")}
            {" "}
            {/* Image Quality: */}
          </strong>
          {t("security:kyc-failed-picture-list-item-1")}
          {/* The images provided for the process did not meet our required
					standards for clarity and quality. This may include issues such as
					blurriness, glare, low resolution, excessive noise, or other factors
					that affect the image's readability and accuracy. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-picture-list-header-2")}
            {" "}
            {/* Unclear Facial Features: */}
          </strong>
          {t("security:kyc-failed-picture-list-item-2")}
          {/* The image provided for facial verification did not sufficiently
					display your facial features, making it challenging to determine your
					identity. This may have been due to low image quality, blurriness,
					shadows, or other factors that hindered the clarity of your facial
					features. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-picture-list-header-3")}
            {" "}
            {/* Similar Faces in the Photo: */}
          </strong>
          {t("security:kyc-failed-picture-list-item-3")}
          {/* In some cases, there appeared to be multiple faces or similar facial
					features in the photo, which made it difficult to isolate and verify
					your unique facial identity accurately. */}
        </li>
      </ul>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-picture-instructions")}
        {/* To address this issue and ensure a successful verification, we kindly
				request that you take the following steps: */}
      </p>
      <ul>
        <li class="list-disc pl-2 ml-4">
          {t("security:kyc-failed-picture-list-item-4")}
          {/* Resubmit High-Quality Images: Please resubmit clear and
					high-resolution images of the required documents, such as your
					identification card (ID), passport, or other requested documents.
					Ensure that the images are well-lit and free from any obstructions,
					shadows, or glare. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          {t("security:kyc-failed-picture-list-item-5")}
          {/* Check Document Condition: Before capturing images, ensure that the
					physical condition of your documents is good, without any folds,
					creases, or damage that may contribute to image quality issues. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          {t("security:kyc-failed-picture-list-item-6")}
          {/* Well-Lit Environment: Capture the images in a well-lit environment to
					improve image quality and reduce shadows. */}
        </li>
      </ul>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-picture-ending")}
        {/* We look forward to receiving your updated documents with improved image
				quality. */}
      </p>
    </>
  );
}

export default SecurityFailedPicture;
